import { ActionContext } from 'vuex';

import api from '@/api';
import { ApiDeviceLayers, ApiDeviceLayersItem } from '@/api/types/device';

interface LayersState {
    list: ApiDeviceLayers;
    listRequestPending: boolean;
}

export interface ILayerForFilter {
    id: number;
    name: string;
    type: string;
}

const layers = {
    namespaced: true,
    state: {
        list: {},
        listRequestPending: false,
    },
    getters: {
        layersForFilter(state: LayersState): Array<ILayerForFilter> {
            const polygons =
                state.list.List?.filter((l) => l.GeographyType === 'Polygon').map((l) => ({
                    id: l.Id,
                    name: l.Name,
                    type: 'Polygon',
                })) || [];

            const categories = [];
            for (const item of state.list?.List || []) {
                if (item.GeographyType !== 'Point') {
                    continue;
                }

                if (typeof item.Category === 'undefined') {
                    continue;
                }

                const categoryIndex = categories.findIndex((c) => c.id === item.Category?.Id);
                if (categoryIndex === -1) {
                    categories.push({
                        id: item.Category.Id,
                        name: item.Category.Name,
                        type: 'Category',
                    });
                }
            }

            return [...polygons, ...categories];
        },
        categoriesForFilter(state: LayersState): Array<ILayerForFilter> {
            const categories = [];
            for (const item of state.list?.List || []) {
                if (typeof item.Category === 'undefined') {
                    continue;
                }

                const categoryIndex = categories.findIndex((c) => c.id === item.Category?.Id);
                if (categoryIndex === -1) {
                    categories.push({
                        id: item.Category.Id,
                        name: item.Category.Name,
                        type: 'Category',
                    });
                }
            }

            return [...categories];
        },
    },
    mutations: {
        startListRequest(state: LayersState): void {
            state.listRequestPending = true;
        },
        endListRequest(state: LayersState): void {
            state.listRequestPending = false;
        },
        updateList(state: LayersState, list: ApiDeviceLayers): void {
            state.list = list;
        },
        clearList(state: LayersState): void {
            state.list = {};
        },
    },
    actions: {
        clearList(context: ActionContext<LayersState, null>): void {
            context.commit('clearList');
        },
        async list(context: ActionContext<LayersState, null>): Promise<void> {
            context.commit('startListRequest');
            try {
                const token = window.localStorage.getItem('authcredentials');
                const response = await api.device.layers(token || '');

                let layers: Array<ApiDeviceLayersItem> = [];
                for (const item of response?.data.List || []) {
                    if (typeof item.Category === 'undefined') {
                        layers = [
                            ...layers,
                            {
                                ...item,
                                Category: {
                                    Id: 0,
                                    Name: '_empty',
                                    Key: '',
                                },
                            },
                        ];
                    } else {
                        layers = [
                            ...layers,
                            {
                                ...item,
                            },
                        ];
                    }
                }
                context.commit('updateList', { ...response.data, List: layers });
            } catch (err) {
                // console.log(err);
            } finally {
                context.commit('endListRequest');
            }
        },
    },
};

export default layers;
